import {ServiceBase} from "../ServiceBase";
import {AnimatedIconObservableTarget, AnimatedIconUnloadReason} from "./animated-icon-base-service.service.interface";
import {AnimationStatus} from "./pixi-animation.interface";

export class AnimatedIconBaseService extends ServiceBase{


    protected loadAnimatedIcon(options: AnimatedIconObservableTarget) {
        if (options.animation && (options.animation.status === AnimationStatus.Loading || options.animation.status === AnimationStatus.Running)) {
            throw new Error("Animated Icon Loading in progress already for this icon. Please be patient");
        }

        let iconPixiAnimation = this.services.pixiApp.createPixiSpineAnimation({
            width: options.size.width,
            height: options.size.height,
            onContextLost: () => {
                if (options.animationDisposer) {
                    options.animationDisposer(AnimatedIconUnloadReason.CONTEXT_LOST);
                }
            }
        }, {"animatedIcon": options.jsonUrl}, {
            render: ({resources}) => {
                let spineAnimation = resources.animatedIcon.spineAnimation;
                // get the animations
                const availableAnimations = resources.animatedIcon.asset.rawAsset.spineData.animations.map(a => a.name);
                const animationToPlay = availableAnimations.indexOf(options.animationName) !== -1 ? options.animationName : availableAnimations[0];

                // play animation
                const runAnimation = () => {
                    // animated icons will have only one animation that we play in loop. There won't be complex timeline animations
                    spineAnimation.state.setAnimation(0, animationToPlay, false);
                }
                let animationSchedule: any;

                spineAnimation.state.addListener({
                    complete: (entry) => {
                        // when animation completes, schedule the next iteration
                        animationSchedule = setTimeout(runAnimation, options.timings.interval);
                    }
                });

                runAnimation();

                options.animationDisposer = (reason: AnimatedIconUnloadReason) => {
                    if (options.onAnimationWillUnload) {
                        options.onAnimationWillUnload(reason);
                    }
                    iconPixiAnimation.dispose();
                };

                return () => {
                    clearTimeout(animationSchedule);
                };
            }
        }, {
            display: "block",
            width: "100%"
        });

        options.animation = iconPixiAnimation;
        options.animationDisposer = iconPixiAnimation.dispose;

        iconPixiAnimation.start().then(({status}) => {
            if (status === AnimationStatus.Running) {
                if (options.onAnimationLoad) {
                    options.onAnimationLoad();
                }
                iconPixiAnimation.attachToDOM(options.wrapper);
            }
        }).catch((e) => {
            // An error occured while loading the animated icon. log the error
            this.services.logger.error(e);
        });
    }
}